// This optional code is used to register a service worker.
// Note this is not required for Create React App, but it is recommended for PWA functionality.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.\d+){0,2}\.\d+$/
  )
);

export function register(config) {
  if ('serviceWorker' in navigator) {
    // Check if service worker is already registered by inline script
    navigator.serviceWorker.getRegistration().then(registration => {
      if (registration) {
        console.log('Service worker already registered by inline script');
        return;
      }
      
      const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
      if (publicUrl.origin !== window.location.origin) {
        return;
      }

      window.addEventListener('load', () => {
        // Use the current path to locate the service worker
        const swUrl = `${window.location.pathname.replace(/\/+$/, '')}/service-worker.js`;

        if (isLocalhost) {
          // This is running on localhost. Let's check if a service worker still exists or not.
          checkValidServiceWorker(swUrl, config);
        } else {
          // Is not localhost. Just register service worker
          registerValidSW(swUrl, config);
        }
      });
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              // Show update notification to user
              if ('serviceWorker' in navigator && 'Notification' in window) {
                if (Notification.permission === 'granted') {
                  new Notification('App Update Available', {
                    body: 'A new version of the app is available. Click here to update.',
                    icon: '/logo192.png'
                  }).onclick = () => {
                    window.location.reload();
                  };
                }
              }

              // Optionally, you can automatically reload to apply updates
              // Uncomment the next line if you want automatic updates without user interaction
              // window.location.reload();
            } else {
              // Content is cached for offline use
              console.log('Content is cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Check for updates every hour
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000);
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
} 